import { type FC } from 'react';

import { ModalContainer, ModalHeader } from '@/utils/modal.tsx';
import { _isNil } from '@/littledash.ts';
import styles from './EventErrorsModal.module.scss';

interface EventErrorsModalProps {
  error: string;
  closeModal: () => void;
}

const EventErrorsModal: FC<EventErrorsModalProps> = ({ error, closeModal }) => {
  return (
    <ModalContainer size="medium">
      <ModalHeader title="Errors" closeModal={closeModal} className={styles.modalHeader} />
      {/* Show complete error message */}
      <div className={styles.modalContent}>
        {!_isNil(error) ? (
          <p className={styles.errorText}>{error}</p>
        ) : (
          <p className={styles.noErrorText}>No errors found.</p>
        )}
      </div>
    </ModalContainer>
  );
};

export default EventErrorsModal;
